import { apiFetch } from '@/api/client'

export type GameLockKind =
  | 'sportsbook'
  | 'casino'
  | 'card'
  | 'liveGame'
  | 'premiumSportsbook'
  | 'horseRacing'
  | 'matchOdds'
  | 'bookmaker'
  | 'customSession'
  | 'completedMatch'
  | 'tiedMatch'
  | 'lineSession'
  | 'transfer'

export type GameStatusGame =
  | 'sportsbook'
  | 'casino'
  | 'cardGame'
  | 'liveGame'
  | 'premiumSportsbook'
  | 'horseRacing'
  | 'matchOdds'
  | 'bookmaker'
  | 'customSession'
  | 'completedMatch'
  | 'tiedMatch'
  | 'lineSession'
  | 'cricket'
  | 'uofMarkets'
  | 'esports'
  | 'greyhoundRacing'
  | 'darts'
  | 'election'
  | 'tennis'
  | 'soccer'
  | 'soccerSuper'
  | 'sportHorseRacing'
  | 'volleyball'
  | 'snooker'
  | 'rugbyLeague'
  | 'artemis'
  | 'rugbyUnion'
  | 'googleAuthenticator'

export type GameLockState = { status: boolean; level: number }
export type GameLocks = Partial<Record<GameLockKind, GameLockState>>
export type GameFlags = Partial<Record<GameStatusGame, boolean>>

export type GameLockResponse = {
  ok: true
  memberId: string
  kind: string
  locking: boolean
  gameLocks: GameLocks
  message: string
}

export type GameStatusResponse = {
  ok: true
  memberId: string
  game: string
  enabled: boolean
  message: string
}

/** Missing flag means On (Lab / Agent-API). */
export function flagOn(flags: GameFlags | undefined, game: GameStatusGame): boolean {
  if (!flags) return true
  return flags[game] !== false
}

export function padlockOn(locks: GameLocks | undefined, kind: GameLockKind): boolean {
  return locks?.[kind]?.status === true
}

/** Lab Member/memberLockFor* — Agent-API `POST /v1/agents/game-lock`. */
export function postGameLock(memberId: string, kind: GameLockKind): Promise<GameLockResponse> {
  return apiFetch<GameLockResponse>('/v1/agents/game-lock', {
    method: 'POST',
    body: JSON.stringify({ memberId, kind }),
  })
}

/** Lab Member/editGameStatus — Agent-API `POST /v1/agents/game-status`. */
export function postGameStatus(
  memberId: string,
  game: GameStatusGame,
  enabled: boolean,
): Promise<GameStatusResponse> {
  return apiFetch<GameStatusResponse>('/v1/agents/game-status', {
    method: 'POST',
    body: JSON.stringify({ memberId, game, enabled }),
  })
}
